module.exports = __webpack_public_path__ + "img/graph.66ac0991.png";